import React, { Component } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@deephaven/components';
import { vsArrowLeft, vsCircleLargeFilled } from '@deephaven/icons';
import "./CommandHistoryActions.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class CommandHistoryActions extends Component {
  static itemKey(i, item) {
    return "".concat(item.title);
  }
  static renderContent(item) {
    if (item.selectionRequired !== undefined && item.selectionRequired) {
      return /*#__PURE__*/_jsxs("div", {
        className: "fa-md fa-layers",
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsCircleLargeFilled,
          mask: item.icon,
          transform: "right-5 down-5 shrink-4"
        }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsArrowLeft,
          transform: "shrink-3 right-7 down-6"
        })]
      });
    }
    return /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: item.icon
    });
  }
  render() {
    var _this$props = this.props,
      actions = _this$props.actions,
      hasSelection = _this$props.hasSelection;
    return /*#__PURE__*/_jsx("div", {
      className: "command-history-actions",
      children: actions.map((item, index) => /*#__PURE__*/_jsx(Button, {
        kind: "inline",
        className: classNames(item.className),
        onClick: item.action,
        tooltip: item.description,
        disabled: item.selectionRequired !== undefined && item.selectionRequired && !hasSelection,
        icon: CommandHistoryActions.renderContent(item)
      }, CommandHistoryActions.itemKey(index, item)))
    });
  }
}
export default CommandHistoryActions;
//# sourceMappingURL=CommandHistoryActions.js.map